import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

class AnalyticsService {
  constructor() {
    this.api = axios.create({
      baseURL: `${API_URL}/analytics`,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Add request interceptor to include auth token
    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        const projectId = localStorage.getItem('currentProjectId');
        if (projectId) config.headers['X-Project-Id'] = projectId;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Add response interceptor for error handling
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          window.location.href = '/signin';
        }
        return Promise.reject(error);
      }
    );
  }

  // Get analytics overview for dashboard
  async getOverview() {
    try {
      const response = await this.api.get('/overview');
      return response.data;
    } catch (error) {
      console.error('Error fetching analytics overview:', error);
      throw error;
    }
  }

  // Get detailed agent analytics
  async getAgentAnalytics() {
    try {
      const response = await this.api.get('/agents');
      return response.data;
    } catch (error) {
      console.error('Error fetching agent analytics:', error);
      throw error;
    }
  }

  // Get workflow analytics
  async getWorkflowAnalytics() {
    try {
      const response = await this.api.get('/workflows');
      return response.data;
    } catch (error) {
      console.error('Error fetching workflow analytics:', error);
      throw error;
    }
  }
}

export default new AnalyticsService();
